/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfilePicture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfilePicture({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/ProfilePicture",
  presignedUrl
  
}) {
let patientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.initials,
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="patient.person"
 format="/Data/format.js initials"
 initials={patientPersonValueData}
 size="large"
 marginBottom="auto"
/>
{children}
</React.Fragment>)
}